import { start } from '@popperjs/core'
import debounce from '../../core/utils/debounce'

const NavArrow = () => {
  const navArrow = document.getElementById('mx-nav-arrow')
  if ( !navArrow ) return

  const OFFSET = 0.9
  const SHOW_AT = 115
  const HEIGHT = window.innerHeight
  const SCROLL_TO = HEIGHT * OFFSET

  const header = document.getElementById('shopify-section-header')
  const navSearch = header.querySelector('.nav-search')
  const navTakeover = header.querySelector('.nav-takeover')

  const toggleOnNav = (mutations, observer) => {
    for ( const mutation of mutations ) {
      const navOpen = mutation.target.classList.contains('show')
      if ( navOpen ) navArrow.classList.add('hide')
      else navArrow.classList.remove('hide')
    }
  }

  const scrollBelowFold = (e) => {
    e.preventDefault()

    navArrow.classList.add('hide')
    window.scrollTo({
      top: SCROLL_TO,
      behavior: 'smooth'
    })

    navArrow.classList.add('hide')

    stopObserving()
  }

  const startObserving = () => {
    observer.observe(navSearch, config)
    observer.observe(navTakeover, config)
  }

  const stopObserving = () => {
    observer.disconnect()
  }

  const observer = new MutationObserver(toggleOnNav)
  const config = { attributes: true, attibuteFilter: ['class'] }

  const toggleOnScroll = () => {
    if ( window.scrollY <= SHOW_AT ) {
      navArrow.classList.remove('hide')
      startObserving()
    }

    if ( window.scrollY >= SCROLL_TO ) {
      navArrow.classList.add('hide')
      stopObserving()
    }
  }

  navArrow.addEventListener('click', scrollBelowFold)

  window.addEventListener('scroll', toggleOnScroll)

  startObserving()
}

export default NavArrow;